import { Card, Col, Form, Row } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../app/store";
import { changeProdutoPredominante, clearError } from "../../../features/manifestoSlice";
import {  MakeMessageError } from "../../../components/Components";
import { TypeCargaProdutoPredominante } from "../../../lists";

export default function ProdutoPredominante(props: any) {
    const formManifesto = useSelector((state: RootState) => state.manifesto.manifesto);
    const errors = useSelector((state: RootState) => state.manifesto.listaErrors);
    const dispatch = useDispatch();

    const handleProdPred = (e: any) => {
        const { name, value } = e.target;
        dispatch(changeProdutoPredominante({ [name]: value }));
        dispatch(clearError('prodPred_' + name))
    }

    return (<div className="px-2">
        <Row className="g-2">
            <Col md={3}>
                <Form.Group className="mb-2">
                    <Form.Label>Tipo de carga</Form.Label>
                    <Form.Select name="tpcarga" value={formManifesto.prodPred.tpcarga}
                        onChange={handleProdPred}>
                        {TypeCargaProdutoPredominante.map(i => {
                            return (
                                <option key={i.id} value={i.id}>{i.name}</option>
                            )
                        })}
                    </Form.Select>

                    <MakeMessageError errors={errors} field="prodPred_tpcarga" />
                </Form.Group>
            </Col>

            <Col md={2}>
                <Form.Group className="mb-2">
                    <Form.Label>CEAN</Form.Label>
                    <Form.Control type="text" maxLength={14} name="cean" value={formManifesto.prodPred.cean}
                        onChange={handleProdPred}
                    />
                    <MakeMessageError errors={errors} field="prodPred_cean" />

                </Form.Group>
            </Col>
            <Col md={2}>
                <Form.Group className="mb-2">
                    <Form.Label>NCM</Form.Label>
                    <Form.Control type="text" maxLength={8} name="ncm" value={formManifesto.prodPred.ncm}
                        onChange={handleProdPred}
                    />
                    <MakeMessageError errors={errors} field="prodPred_ncm" />
                </Form.Group>
            </Col>
            <Col md>
                <Form.Group className="mb-2">
                    <Form.Label>Descrição do produto</Form.Label>
                    <Form.Control type="text" name="xprod" value={formManifesto.prodPred.xprod}
                        onChange={handleProdPred}
                    />
                    <MakeMessageError errors={errors} field="prodPred_xprod" />
                </Form.Group>
            </Col>
        </Row>
        {/* <Row>
            <Col md={'auto'} className="d-flex align-items-end ">
                <Form.Group controlId="active">
                    <Form.Switch className="mb-0" type="switch" name="prodPred_infLotacao" label="Informar Lotação"
                        title="Carga Lotação"
                        onChange={handleProdPred}
                    />
                </Form.Group>
            </Col>
        </Row> */}

        {formManifesto.prodPred.infLotacao && (

        <Row >
            <Col md={6}>

                <Card className="card-primary card-outline">
                    <Card.Header >
                        <h6 className="py-0 my-1">
                            <span className="text-dark">Inf. Local Carregamento</span>
                        </h6>
                    </Card.Header>

                    <Card.Body>
                        <Row>
                            <Col md={2}>
                                <Form.Group className="mb-2">
                                    <Form.Label>CEP</Form.Label>
                                    <Form.Control type="text" name="xprod"
                                        value={formManifesto.prodPred.infLocalCarrega_cep} maxLength={8}
                                        onChange={handleProdPred} />
                                    <MakeMessageError errors={errors} field="prodPred_infLocalCarrega_cep" />
                                </Form.Group>
                            </Col>

                            <Col md>
                                <Form.Group className="mb-2">
                                    <Form.Label>Latitude</Form.Label>
                                    <Form.Control type="text" name="xprod"
                                        value={formManifesto.prodPred.infLocalCarrega_latitude} maxLength={10}
                                        onChange={handleProdPred} />
                                    <MakeMessageError errors={errors} field="prodPred_infLocalCarrega_latitude" />
                                </Form.Group>
                            </Col>

                            <Col md>
                                <Form.Group className="mb-2">
                                    <Form.Label>Longitude</Form.Label>
                                    <Form.Control type="text" name="xprod"
                                        value={formManifesto.prodPred.infLocalCarrega_longetude} maxLength={11}
                                        onChange={handleProdPred} />
                                    <MakeMessageError errors={errors} field="prodPred_infLocalCarrega_longetude" />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Col>
            <Col md={6}>

                <Card className="card-primary card-outline">
                    <Card.Header >
                        <h6 className="py-0 my-1">
                            <span className="text-dark">Inf. Local Descarregamento</span>
                        </h6>
                    </Card.Header>

                    <Card.Body>
                        <Row>
                            <Col md={2}>
                                <Form.Group className="mb-2">
                                    <Form.Label>CEP</Form.Label>
                                    <Form.Control type="text" name="xprod"
                                        value={formManifesto.prodPred.infLocalDescarrega_cep} maxLength={8}
                                        onChange={handleProdPred} />
                                    <MakeMessageError errors={errors} field="prodPred_infLocalDescarrega_cep" />
                                </Form.Group>
                            </Col>

                            <Col md>
                                <Form.Group className="mb-2">
                                    <Form.Label>Latitude</Form.Label>
                                    <Form.Control type="text" name="xprod"
                                        value={formManifesto.prodPred.infLocalDescarrega_latitude} maxLength={10}
                                        onChange={handleProdPred} />
                                    <MakeMessageError errors={errors} field="prodPred_infLocalDescarrega_latitude" />
                                </Form.Group>
                            </Col>

                            <Col md>
                                <Form.Group className="mb-2">
                                    <Form.Label>Longitude</Form.Label>
                                    <Form.Control type="text" name="xprod"
                                        value={formManifesto.prodPred.infLocalDescarrega_longetude} maxLength={11}
                                        onChange={handleProdPred} />
                                    <MakeMessageError errors={errors} field="prodPred_infLocalDescarrega_longetude" />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
        )}
    </div>)
}